export default __webpack_public_path__ + "static/media/faviconBag.32f68210.png";